<template>
  <div class="container">
    <HeadingOne class="-margin-md">ログインID設定</HeadingOne>

    <ErrorsAlert :errors="errors" :column-only="true"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="2" type="localid"></MainWizard>
    </WizardGroup>

    <p>内容をご確認のうえ、よろしければ「設定する」を押してください。</p>

    <section>
      <TableGroup>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader class="-entry">電話番号</TableHeader>
              <TableData>{{ displayPhone }}</TableData>
            </TableRow>
            <TableRow>
              <TableHeader class="-entry">メールアドレス</TableHeader>
              <TableData
                >メールアドレスは、ログインIDとして使用します。<br />{{
                  localUserData.local_mail
                }}</TableData
              >
            </TableRow>
            <TableRow>
              <TableHeader class="-entry">パスワード</TableHeader>
              <TableData>{{ displayLocalPasswd }}</TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>
    </section>

    <NoticeBox class="-point _mb-sm-40 _mb-md-60">
      <NoticeHeader class="_mb-0">
        <h3 class="heading">
          au PAY
          スマートローンのご利用にあたって重要な情報となりますので、第三者に知られないようお客様において大切にお取り扱いください。
        </h3>
      </NoticeHeader>
    </NoticeBox>

    <form novalidate @submit.prevent="submitLocalId">
      <BtngroupSingle class="_mb-sm-40">
        <BtnMain class="-main" @click.prevent="submitLocalId">
          設定する
        </BtnMain>
      </BtngroupSingle>

      <BtngroupSingle class="-margin-lg">
        <BtnBack class="-back -md" router-name="ce006"> 修正する </BtnBack>
      </BtngroupSingle>
    </form>
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import { initCredentials } from "@/utils/Auth";
import { localIdUserLocalIdRegister } from "@/utils/LocalLoginHelper";
import { goToErrorPage } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import ErrorsAlert from "@/components/alert/ErrorsAlert";

export default {
  name: "Ce004",
  components: {
    ErrorsAlert,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "ログインID設定",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローカルID,認証方法",
    });
  },
  data() {
    return {
      errors: {},
      isDisabled: false,

      localIdData: {
        account_id: "",
        lastname_kana: "",
        firstname_kana: "",
        birtyday: "",
        secret_word_ask: "",
        secret_word_ans: "",
      },
      localUserData: {
        phone_1: "",
        phone_1_confirmation: "",
        phone_2: "",
        phone_2_confirmation: "",
        phone_3: "",
        phone_3_confirmation: "",
        local_mail: "",
        local_mail_confirmation: "",
        local_passwd: "",
        local_passwd_confirmation: "",
      },
      localIdRegisterData: {
        account_id: "",
        phone_1: "",
        phone_2: "",
        phone_3: "",
        local_mail: "",
        local_passwd: "",
      },
    };
  },
  computed: {
    displayPhone() {
      return [
        this.localUserData.phone_1,
        this.localUserData.phone_2,
        this.localUserData.phone_3,
      ].join("-");
    },
    displayLocalPasswd() {
      let result = "";
      for (let i = 0; i < this.localUserData.local_passwd.length; i++) {
        result = result + "*";
      }
      return result;
    },
  },
  mounted() {
    this.localUserData = JSON.parse(localStorage.getItem("local_login_data"));
    this.localIdData = JSON.parse(localStorage.getItem("local_id_data"));
    this.localIdRegisterData["account_id"] = this.localIdData.account_id;
    this.localIdRegisterData["phone_1"] = this.localUserData.phone_1;
    this.localIdRegisterData["phone_2"] = this.localUserData.phone_2;
    this.localIdRegisterData["phone_3"] = this.localUserData.phone_3;
    this.localIdRegisterData["local_mail"] = this.localUserData.local_mail;
    this.localIdRegisterData["local_passwd"] = this.localUserData.local_passwd;
  },
  methods: {
    submitLocalId() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            localIdUserLocalIdRegister(this.localIdRegisterData)
              .then(() => {
                this.$router.push({ name: "ce005" });
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
